import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { DropdownIconButton } from 'components';

import CloseIcon from '@material-ui/icons/Close';
// import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { useStyles } from './styles';

const MultipleSelectField = ({
  selectedItem,
  list,
  availableItems,
  notAvailableToDeleteItems,
  addItem,
  deleteItem,
  selectItem,
  className
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const isAvailableToDelete = item => {
    return !notAvailableToDeleteItems.filter(
      notAvailableItem => notAvailableItem === item
    ).length;
  };

  const onDeleteHandler = (e, item) => {
    e.stopPropagation();
    deleteItem(item);
  };

  return (
    <div className={classNames(classes.wrapper, className)}>
      {list.map((item, index) => (
        <div
          key={index}
          onClick={() => selectItem(item)}
          className={classNames(classes.item, {
            [classes.selected]: selectedItem === item
          })}
        >
          {item}
          {isAvailableToDelete(item) && (
            <CloseIcon
              className={classes.closeBtn}
              onClick={e => onDeleteHandler(e, item)}
            />
          )}
        </div>
      ))}
      {availableItems.length > 0 && (
        <DropdownIconButton list={availableItems} click={addItem}>
          {t('New language')}
        </DropdownIconButton>
      )}
    </div>
  );
};

export default MultipleSelectField;
